import _ from 'lodash';

export const catchErrors = (data) => {
  const errors = {};

  if (!data.practiceId) {
    errors.practiceId = 'Practice ID is required';
  }

  if (!data.departmentId) {
    errors.departmentId = 'Department is required';
  }

  return {
    errors,
    hasErrors: !_.isEmpty(errors),
  };
};
